module.exports = __webpack_public_path__ + "img/modal-bottom-barcode-bg.3c43b87a.png";